import type { alertsFr } from './alerts.fr';

type DeepStrings<T> = { [K in keyof T]: T[K] extends string ? string : DeepStrings<T[K]> };

/** English texts for job alerts (2026-10-19). Same keys as `alerts.fr.ts`. */
export const alertsEn: DeepStrings<typeof alertsFr> = {
  title: 'Alerts',
  description:
    'Get told when a run starts, succeeds or fails: by signed webhook or by email. The failure alert links to the run.',
  add: 'Add an alert',
  addTitle: 'New alert',
  addDescription:
    'A webhook receives the alert as JSON, signed with a secret of its own; it is shown only once, when you save.',
  empty: 'No alert',
  emptyHelp: 'Add a webhook or an email to be told how runs end.',
  remove: 'Remove',
  removeLabel: 'Remove the alert {{target}}',
  saved: 'Alerts saved.',
  removed: 'Alert removed.',
  removeFailed: 'Alert not removed: try again.',
  columns: {
    event: 'When',
    type: 'Channel',
    target: 'Destination',
    signature: 'Signature',
    logTail: 'Log tail',
  },
  events: {
    on_start: 'On start',
    on_success: 'On success',
    on_failure: 'On failure',
  },
  types: {
    webhook: 'Webhook',
    mail: 'Email',
    eventhub: 'Azure Event Hub',
    other: 'Other ({{type}})',
  },
  signed: 'Signed',
  unsigned: 'Not signed: remove it and add it again to get a secret',
  logTailOn: 'Attached',
  logTailOff: '—',
  fields: {
    event: 'When',
    type: 'Channel',
    url: 'Webhook URL',
    urlHelp: 'https in practice; never an internal address (refused when sending).',
    method: 'Method',
    includeLogTail: 'Attach the end of the log to the failure alert',
    includeLogTailHelp: 'Off by default: a log may hold data.',
    to: 'Recipient',
    subject: 'Subject (optional)',
  },
  errors: {
    url: 'An http(s) URL is expected.',
    to: 'An email address is expected.',
  },
  secret: {
    title: 'Signing secret',
    description:
      'Copy it now: it will never be shown again. Each alert carries X-Graal-Signature: t=<timestamp>,v1=<HMAC-SHA256(secret, t.body)>.',
    copy: 'Copy the secret',
    copied: 'Secret copied.',
    copyFailed: 'Copy failed: select the secret by hand.',
    once: 'Shown only once. Lost: remove the alert and add it again.',
    done: 'I have saved the secret',
    verify: 'Checking on the receiving side',
  },
  deliveries: {
    title: 'Latest deliveries',
    description: 'Kept 30 days (200 at most), retries included. No header, body or URL parameter.',
    empty: 'No delivery',
    emptyHelp: 'Sent alerts will show here, with their outcome.',
    columns: {
      at: 'When',
      event: 'Event',
      type: 'Channel',
      outcome: 'Outcome',
      attempts: 'Attempts',
      detail: 'Detail',
      destination: 'Destination',
      run: 'Run',
    },
    outcomes: {
      delivered: 'delivered',
      failed: 'failed',
      blocked: 'destination refused',
    },
    http: 'HTTP {{code}}',
  },
};
